import React from 'react';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';

import { QuoteChargeListingEntity } from '../../../../types';
import { quoteChargeCalculator } from '../../../../lib/quoteChargeCalculator';

export const EquipmentChargeGrandTotalCell = ({ priceCalc }: { priceCalc: QuoteChargeListingEntity[] }) => {
  return <Typography>Total: {formatCurrency(quoteChargeCalculator.getGrandTotal(priceCalc) ?? null, true)}</Typography>;
};
